export default {
    seasons: [],
    totalFromServer: 0,
    loading: true,
}
